import { render, staticRenderFns } from "./PdfSignaturePlacer.vue?vue&type=template&id=2f412fd2&scoped=true"
import script from "./PdfSignaturePlacer.vue?vue&type=script&lang=js"
export * from "./PdfSignaturePlacer.vue?vue&type=script&lang=js"
import style0 from "./PdfSignaturePlacer.vue?vue&type=style&index=0&id=2f412fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f412fd2",
  null
  
)

export default component.exports